import { DEFAULT_REQUEST_START_SUB_STEP } from "@/constants";
import { appConfig } from "@/guards/auth/azure-b2c.config";
import {
  Person,
  RequestResponse,
  selectRequestFormStore,
  useBoundStore,
} from "@/services";
import { getBooleanConfigValue } from "@/utils";
import { map, size } from "lodash";
import { useCallback, useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { UsersA } from "./components/user-a-table";
import { UsersB } from "./components/user-b-table";
import styles from "./styles.scss";
import { UsersField } from "./types";

export const UsersTableForm = ({
  subStep,
  data,
}: {
  subStep: string;
  data: RequestResponse | null;
}) => {
  const { requestFormData, setRequestFormData } = useBoundStore(
    selectRequestFormStore,
  );

  const {
    clearErrors,
    getValues,
    setValue,
    setError,
    formState: { errors, isValid },
    trigger,
  } = useFormContext();

  if (getBooleanConfigValue(appConfig?.FEATURES?.IS_DEBUG_ENABLED)) {
    /* eslint-disable */
    console.log(UsersField.Users, errors, isValid);
    /* eslint-enable */
  }

  useEffect(() => {
    if (!size(requestFormData?.Personnels)) {
      setError("init", { message: UsersField.Users });

      trigger(UsersField.Users);
      trigger(UsersField.UsersAccurancy);
    }
  }, [getValues, requestFormData?.Personnels, setError, trigger]);

  const handleDataChange = useCallback(
    async (value: Person[], dropdownId: UsersField.Users) => {
      clearErrors(dropdownId);
      setValue(dropdownId, value);

      await trigger(UsersField.Users);
    },
    [clearErrors, setValue, trigger],
  );

  const handleSetAccurancy = useCallback(
    async (value: boolean) => {
      clearErrors(UsersField.UsersAccurancy);
      setValue(UsersField.UsersAccurancy, value);

      if (getBooleanConfigValue(appConfig?.FEATURES?.IS_DEBUG_ENABLED)) {
        /* eslint-disable */
        console.log("getValues ", getValues(UsersField.UsersAccurancy));
        /* eslint-enable */
      }

      await trigger(UsersField.UsersAccurancy);
    },
    [clearErrors, setValue, trigger, getValues],
  );

  /**
   * Edit mode
   */

  useEffect(() => {
    if (data) {
      const { LoaWorkers, LOARequestBasicDetails } = data;

      if (LoaWorkers?.LoaWorkers?.length) {
        const users = map(LoaWorkers?.LoaWorkers, worker => ({
          ...worker,
          Value: worker?.WorkerEidUnifiedNumber,
        }));

        handleDataChange(users, UsersField.Users).then(() => {
          setRequestFormData(UsersField.Users, users);
        });
      }

      handleSetAccurancy(
        LOARequestBasicDetails?.IsAccuracyOfInfoChecked || false,
      );
    }
  }, [data, handleDataChange, handleSetAccurancy, setRequestFormData]);

  return (
    <>
      {subStep === DEFAULT_REQUEST_START_SUB_STEP ? (
        <UsersA onSelectUser={handleDataChange} />
      ) : (
        <UsersB
          className={styles.tableWrapStep}
          onSetAccurancy={handleSetAccurancy}
        />
      )}
    </>
  );
};
